export abstract class AutodeskDmFolder {
  public id: string = "";
  public attributes!: AutodeskDmFolderAttributes;
  public type = "";
}

class AutodeskDmFolderAttributes {
  name: string = "";
  displayName: string = "";
  type: string = "";
}
